import dayjs from "dayjs";

export const formatPrice = (price: number) => {
  return price.toLocaleString('vi-VN', { style: 'currency', currency: 'VND' });
};

export const formatDate = (date: Date) => {
  return dayjs(date).format('DD/MM/YYYY');
};